$(document).ready(function() {
    $("#account-sel-form a.list-group-item").click(function(event) {
        var id = $(this).data("account-id");
        $("input#id").val(id); // set id of hidden element
        $("#account-sel-form").submit();
    });
});